import { useMutation, useQueryClient } from "@tanstack/react-query";

import { UpsertDocScanCropsPayload, upsertDocScanCrops } from "services";

import { invalidateQueriesByChunk } from "utils";

import { GET_FIELDS_CROP_RECOMMENDATIONS, GET_FIELD_PRACTICES } from "consts";

export const useUpsertDocScanCrops = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: ({ docScanId, payload }: { docScanId: string; payload: UpsertDocScanCropsPayload }) => upsertDocScanCrops(docScanId, payload),
    onSuccess: (_, variables) => {
      variables.payload.fields.forEach((f) => {
        invalidateQueriesByChunk(GET_FIELD_PRACTICES, f.fieldId);
        queryClient.invalidateQueries({ queryKey: [GET_FIELDS_CROP_RECOMMENDATIONS, [f.fieldId]] });
      });
    },
  });
};
